<template>
  <div class="scroll popups" @click.stop="close" v-show="showPopup">
    <div
      class="bg-FFFFFF w-full fb fb-col popup"
      :class="showPopup ? 'show-popups' : 'hide-popups'"
      @click.stop="handlerClickPopup"
    >
      <div class="p-8-0 p-0-8 scroll item-flex-1  popup-content">
        <div class="p-0-16 p-16-0 ff-regular">
          <div class="popup-content bg-F6F6F6 " v-show="showPopup">
            <div class="attendance-type c-C0C0C0 font-26 text-center "
              >请选择考勤类型</div
            >
            <div class="common-attendance" @click="handlerAttendance(0)">
              <div class=" ff-medium common">
                <p class="text-blod">通用考勤</p>
                <span class=" c-C0C0C0 "
                  >适用于学生统一进出校门、教学楼的考勤管理</span
                >
              </div>
            </div>
            <div class="accommodation-attendance" @click="handlerAttendance(1)">
              <div class="accommodation ff-medium">
                <p class="text-blod">住宿生考勤</p>
                <span class="c-C0C0C0 "
                  >住宿生考勤针对于住宿生设置，可以实现平时的离/归寝考勤和周末的离/归校考勤</span
                ></div
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showPopup: this.show,
      role: 0,
      level: {
        1: 'guardian',
        2: 'headmaster',
        3: 'admin'
      }
    }
  },
  computed: {},
  watch: {
    show(show) {
      this.showPopup = show
    }
  },
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    close() {
      this.showPopup = false
      this.$emit('close', false)
    },
    handlerClickPopup() {
      return false
    },
    handlerAttendance(type) {
      this.handlerClearStoreCommit()
      let _path = ['/attendance/group/save', '/attendance/dorm/save']
      this.$router.push({
        path: _path[type],
        query: {}
      })
    },
    handlerClearStoreCommit() {
      this.$store.commit('saveGroupName', null)
      this.$store.commit('saveGroupMember', null)
      this.$store.commit('saveGroupDepts', null)
      this.$store.commit('currentTagId', null)
      this.$store.commit('attendanceDays', null)
      this.$store.commit('saveGroupDeviceIds', null)
      this.$store.commit('saveEntranceDevice', ['deviceIds', null])
      this.$store.commit('saveEntranceDevice', ['attendanceDays', null])
      this.$store.commit('saveEntranceDevice', ['weekDeployDtoList', null])
      this.$store.commit('attendanceDate', [])
      this.$store.commit('saveGroupDtoList', null)
      this.$store.commit('saveGroupGuardian', null)
      this.$store.commit('attendanceGroupId', null)
    }
  }
}
</script>

<style lang="scss" scoped>
.popups {
  background: rgba(0, 0, 0, 0.28);
  width: 100vw;
  height: 100vh;
  position: fixed;
  z-index: 99;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  .popup {
    transition: all ease 0.6s;
    border-radius: 11px 11px 0px 0px;
    position: absolute;
    left: 0;
    bottom: -100vh;
    max-height: 80%;
    width: 100%;
  }
  .popup-close {
    position: absolute;
    top: 23px;
    transform: translateY(-50%);
    right: -16px;
    padding: 0 16px;
  }
  .hide-popups {
    bottom: -100vh;
  }
  .show-popups {
    bottom: 0;
  }
  .popup-header {
    z-index: 999999;
    border-radius: 11px 11px 0px 0px;
  }
  .popup-content {
    position: fixed;
    height: 334px;
    bottom: 0;
    left: 0;
    width: 100%;
    -webkit-transition: all 0.2s ease-in;
    transition: all 0.2s ease-in;
    border-radius: 3px;
    .attendance-type {
      height: 50px;
      line-height: 50px;
    }
    .common-attendance {
      width: 89%;
      height: 35.3%;
      position: absolute;
      left: 50%;
      top: 14.97%;
      transform: translateX(-50%);
      background-color: #fff;
      box-shadow: 0, 0, 4px, #000000;
      border-radius: 2px;
      .common {
        font-size: 17px;
        width: 90.6%;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        span {
          font-size: 14px;
        }
      }
    }
    .accommodation-attendance {
      font-size: 17px;
      width: 89%;
      height: 35.3%;
      position: absolute;
      left: 50%;
      top: 55%;
      transform: translateX(-50%);
      background-color: #fff;
      box-shadow: 0px, 0px, 4px, #000000;
      border-radius: 2px;
      .accommodation {
        width: 90.6%;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        span {
          font-size: 14px;
        }
      }
    }
  }
}
</style>
